import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { SingleSearchField, SingleSearchFieldProps } from './SingleSearchField';
import { MeiliIndex, SearchDatabaseResultItem, MeiliTrackData } from './types';
import { TypedMemo } from '../../../common/types';

export type TrackSearchFieldProps = Omit<SingleSearchFieldProps, 'queryType' | 'onSelected' | 'placeholder'> & {
  onTrackSelected: (track: MeiliTrackData) => void;
  placeholder?: string;
};

const TrackSearchFieldComponent: React.FC<TrackSearchFieldProps> = ({ onTrackSelected, placeholder, ...props }) => {
  const intl = useIntl();

  const defaultPlaceholder = intl.formatMessage({
    id: 'app.search.tracks.placeholder',
    defaultMessage: 'Search for tracks...',
  });

  const handleSelected = useCallback(
    (item: SearchDatabaseResultItem) => {
      if (item.type === MeiliIndex.tracks) {
        onTrackSelected(item.item);
      }
    },
    [onTrackSelected]
  );

  return (
    <SingleSearchField
      queryType={MeiliIndex.tracks}
      onSelected={handleSelected}
      placeholder={placeholder || defaultPlaceholder}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

export const TrackSearchField = TypedMemo(TrackSearchFieldComponent);
